import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProtectedRoute from '@/components/ProtectedRoute';
import PublicRoute from '@/components/PublicRoute';
import SettingsLayout from '@/components/SettingsLayout';
import ProductOSBadge from '@/components/ProductOSBadge';
import SproutPage from '@/pages/SproutPage';
import AuthPage from '@/pages/AuthPage';
import PricingPage from '@/pages/PricingPage';
import DashboardPage from '@/pages/DashboardPage';
import ChatPage from '@/pages/ChatPage';
import ProfilePage from '@/pages/ProfilePage';
import PlansPage from '@/pages/PlansPage';
import AgentsPage from '@/pages/AgentsPage';

function AppRouter() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Hide navbar/footer on app-shell pages (agents page hides its own chrome when authed)
  const isAppShell =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/chat') ||
    location.pathname.startsWith('/settings') ||
    (location.pathname.startsWith('/agents') && isAuthenticated);

  return (
    <>
      {!isAppShell && <Navbar />}
      <Routes>
        <Route path="/" element={<PublicRoute><SproutPage /></PublicRoute>} />
        <Route path="/auth" element={<PublicRoute><AuthPage /></PublicRoute>} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat/:projectId"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />
        <Route path="/agents" element={<AgentsPage />} />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsLayout />
            </ProtectedRoute>
          }
        >
          <Route path="profile" element={<ProfilePage />} />
          <Route path="plans" element={<PlansPage />} />
        </Route>
      </Routes>
      {!isAppShell && <Footer />}
      <ProductOSBadge />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
